import { Hsl, hslToStr } from 'annotation-tools/utils';

export const colorDef = {
  appBar: hslToStr([0, 0, 33]),
  bg: 'white',
  paper: hslToStr([0, 0, 92]),
  paperLighter: hslToStr([0, 0, 96]),
  white: 'white',
  black: 'black',
  messageArea: {
    default: hslToStr([0, 0, 93]),
    warning: hslToStr([43, 100, 92]),
    alert: hslToStr([358, 100, 95])
  }
} as const;

export const defaultHue = 0;
export const defaultSaturation = 80;
export const defaultLightness = 50;
export const defaultHsl: Hsl = [
  defaultHue,
  defaultSaturation,
  defaultLightness
];
